import matchesActiveIf from 'Pods/ThreeDStudio/Hooks/matchesActiveIf'
import { MODEL_SOURCES } from 'Pods/ThreeDStudio/Services/Constants/modelSources'
import { threeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { setAvailableEnhancedProviders } from 'Pods/ThreeDStudio/Store/actions/schema'

import { getHiddenEnhancedProviders } from './getHiddenEnhancedProviders'

/**
 * Resolves the enhanced model schema for the current viewer-sidebar tab. Filters
 * MODEL_SOURCES by the tab-derived `enhancedAction`, then by `active_if` against
 * the tab's settings slice (remeshSettings, textureSettings, ...). As a side
 * effect, syncs `availableEnhancedProviders` and may resync `enhancedProvider`.
 *
 * @param {string|null} enhancedAction - From schema.enhancedAction (kept in sync
 *   with state.ui.activeViewerSidebarTab by setActiveViewerSidebarTab).
 * @param {Object} enhancedSettings - The slice corresponding to the active tab
 *   (`state[\`${activeViewerSidebarTab}Settings\`]`). Empty object when the tab
 *   does not map to a settings slice.
 * @param {Object} featureFlags - Per-user flag values from pageConfig
 *   (enableHunyuanSegmentation, enableMeshyRemesh); a provider gated by an off
 *   flag is excluded from its flow (see getHiddenEnhancedProviders).
 * @returns {Object|undefined} - Eligible schema for the active enhanced
 *   provider, or undefined when no schema matches.
 */
export const getNextEnhancedSchema = (enhancedAction, enhancedSettings, featureFlags) => {
  const hiddenProviders = getHiddenEnhancedProviders(enhancedAction, featureFlags)
  const candidates = MODEL_SOURCES.filter(model =>
    model.action === enhancedAction && !hiddenProviders.includes(model.provider)
  )
  const eligible = candidates.filter(schema => matchesActiveIf(schema, enhancedSettings))
  const providers = [...new Set(eligible.map(schema => schema.provider))]
  setAvailableEnhancedProviders(providers)
  const activeProvider = threeDStudioStore.getState().schema.enhancedProvider

  return eligible.find(schema => schema.provider === activeProvider)
}
